enum ActionTypes {
  LOAD_RECENT_UNACKNOWLEDGED_NOTIFICATIONS_REQUEST = 'LOAD_RECENT_UNACKNOWLEDGED_NOTIFICATIONS_REQUEST',
  LOAD_RECENT_UNACKNOWLEDGED_NOTIFICATIONS_SUCCESS = 'LOAD_RECENT_UNACKNOWLEDGED_NOTIFICATIONS_SUCCESS',
  LOAD_RECENT_UNACKNOWLEDGED_NOTIFICATIONS_FAILURE = 'LOAD_RECENT_UNACKNOWLEDGED_NOTIFICATIONS_FAILURE',

  LOAD_PAGINATED_NOTIFICATIONS_REQUEST = 'LOAD_PAGINATED_NOTIFICATIONS_REQUEST',
  LOAD_PAGINATED_NOTIFICATIONS_SUCCESS = 'LOAD_PAGINATED_NOTIFICATIONS_SUCCESS',
  LOAD_PAGINATED_NOTIFICATIONS_FAILURE = 'LOAD_PAGINATED_NOTIFICATIONS_FAILURE',

  ACKNOWLEDGE_NOTIFICATION_REQUEST = 'ACKNOWLEDGE_NOTIFICATION_REQUEST',
  ACKNOWLEDGE_NOTIFICATION_SUCCESS = 'ACKNOWLEDGE_NOTIFICATION_SUCCESS',
  ACKNOWLEDGE_NOTIFICATION_FAILURE = 'ACKNOWLEDGE_NOTIFICATION_FAILURE',
  SET_PENDING_ACKNOWLEDGEMENT = 'SET_PENDING_ACKNOWLEDGEMENT',
  REMOVE_PENDING_ACKNOWLEDGEMENT = 'REMOVE_PENDING_ACKNOWLEDGEMENT',

  BULK_ACKNOWLEDGE_NOTIFICATIONS_REQUEST = 'BULK_ACKNOWLEDGE_NOTIFICATIONS_REQUEST',
  BULK_ACKNOWLEDGE_NOTIFICATIONS_SUCCESS = 'BULK_ACKNOWLEDGE_NOTIFICATIONS_SUCCESS',
  BULK_ACKNOWLEDGE_NOTIFICATIONS_FAILURE = 'BULK_ACKNOWLEDGE_NOTIFICATIONS_FAILURE',

  SET_NOTIFICATION = 'SET_NOTIFICATION',
  SET_PAGINATED_NOTIFICATIONS = 'SET_PAGINATED_NOTIFICATIONS',
  SET_RECENT_UNACKNOWLEDGED_NOTIFICATIONS = 'SET_RECENT_UNACKNOWLEDGED_NOTIFICATIONS'
}

export default ActionTypes;
